/**
 * Search Modal functionality
 * @class
 */
export default class SearchModal {
    /**
     * @constructor
     * @param {HTMLElement} element The search modal root element
     */
    constructor(element) {
        this.element = element;
        this.triggers = [...document.querySelectorAll('[data-button="ToggleSearch"]')];
        this.html = document.querySelector('html');
        this.triggers.forEach(trigger => trigger.addEventListener('click', () => {
            this.element.classList.toggle('is-open');
            this.html.classList.toggle('is-locked');
        }));
    }
    /**
     * Creates new instances of ISearchModalUtils for each `[data-component="SearchModal"]` element,
     * and adds the necessary event listeners to support opening and closing of the navigation.
     */
    static init() {
        const searchModals = [...document.querySelectorAll('[data-component="SearchModal"]')];
        searchModals.forEach(searchModal => {
            const searchMoadlUtil = new SearchModal(searchModal);
        });
    }
}
